module.exports = __webpack_public_path__ + "img/pt-7.dac30f31.jpg";